// extracted by mini-css-extract-plugin
export var orderSummary = "_og-0";
export var showMoreLessButton = "_og-1";